import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"
import { sendEmailOtpApiCall, verifyEmailOtpApiCall } from '@/services/api'

import '@/pages/profile/sections/common.css'
import "./otpVerification.css"
import { useEffect, useRef, useState } from 'react';

export default function OtpVerification(props: any) {
    const { common, profile } = useLocalTranslation();

    const allOtpStatus = {
        sendingOtp: common.statusText.sendingOtpBtn,
        verifyOtp: common.statusText.verifyBtn,
        verifyingOtp: common.statusText.verifyingBtn
    } as const

    const [optStatus, setOptStatus] = useState("")
    const [otpResendCounter, setOtpResendCounter] = useState(0)
    const [otp, setOtp] = useState("")
    const [errMsg, setErrMsg] = useState("")
    const isFirstRun = useRef(true);


    useEffect(() => {
        if (otpResendCounter <= 0) {
            return;
        }

        const timer = setInterval(() => {
            setOtpResendCounter((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [otpResendCounter]);




    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            if (optStatus !== allOtpStatus.sendingOtp) {
                callGetEmailOtpApi();
            }
        }
    }, []);

    const callGetEmailOtpApi = async () => {
        setOptStatus(allOtpStatus.sendingOtp)
        const payload = {
            "email": props.email
        }
        const sendEmailOtpApiCallStatus = await sendEmailOtpApiCall(payload)
        if (sendEmailOtpApiCallStatus.status) {
            setOtpResendCounter(120) // 2 mins
            setOptStatus(allOtpStatus.verifyOtp)
        } else {
            setOptStatus("")
        }
    }

    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    };


    const handleVerify = async () => {
        setOptStatus(allOtpStatus.verifyingOtp)
        if (otp !== "") {
            console.log('Otp is correct redirect ....')
            const payload = {
                otp: otp
            }
            const verifyEmailOtpApiCallStatus = await verifyEmailOtpApiCall(payload)
            if (verifyEmailOtpApiCallStatus.status) {
                setOptStatus(allOtpStatus.verifyOtp)
                props.handleSubmit(listOfSections.otpVerification)
            } else {
                setErrMsg(common.statusText.incorrectOtp)
                setOptStatus(allOtpStatus.verifyOtp)

            }
        } else {            
            setErrMsg(common.statusText.pleaseGiveInput)
            setOptStatus(allOtpStatus.verifyOtp)
        }
    }

    const handleOtpChange = (e: any) => {
        setErrMsg("")
        const val = e.target.value
        setOtp(val)
    }

    const handleReSendOtp = () => {
        setErrMsg("")
        callGetEmailOtpApi()
    }

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.otpVerification}
                <span className='text-[#FF2828]'>*</span>
            </p>
            <p className='commonH3'>
                {profile.basicDetailsSection.notes.n4}
            </p>

            {errMsg !== "" &&
                <p className='commonErr1'>{errMsg}</p>
            }

            <input
                value={otp}
                onChange={(e) => handleOtpChange(e)}
                type="number"
                placeholder="0000"
                className="
                profileOtpVerificationInputBox
                rounded-[5px]                
                px-[10px] py-[2px]
                text-[30px] 
                font-medium 
                w-[100%]
            "
            ></input>


            <div className='flex justify-between text-[14px] mt-[10px]'>
                <button
                    onClick={handleReSendOtp}
                    disabled={optStatus !== allOtpStatus.verifyOtp || otpResendCounter > 0}
                    style={{
                        cursor: (optStatus !== allOtpStatus.verifyOtp || otpResendCounter > 0) ? 'not-allowed' : "pointer",
                        color: (optStatus !== allOtpStatus.verifyOtp || otpResendCounter > 0) ? "#A5A5A5" : "#1573FE"
                    }}
                    className='underline'
                >
                    {common.statusText.resendOtpBtn}
                </button>

                {otpResendCounter > 0 &&
                    <p className='text-[#656262]'>
                        {common.statusText.resendOtpIn}{' '}
                        {/* {otpResendCounter} */}
                        {formatTime(otpResendCounter)}
                    </p>
                }
            </div>


            <div className='commonBtnCon1'>
                <button
                    disabled={optStatus !== allOtpStatus.verifyOtp}
                    onClick={handleVerify}
                    style={{
                        cursor: optStatus === allOtpStatus.verifyOtp ? 'pointer' : 'not-allowed',
                        backgroundColor: optStatus === allOtpStatus.verifyOtp ? '#1573FE' : '#9f9f9f'
                    }}
                    className='py-[6px] w-[100%] text-white rounded-[5px]'>
                    {optStatus}
                </button>

            </div>
        </div>
    );
}
